/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AuthService } from './services/auth.service';
import { BusinessCentralService } from './services/business-central.service';
import { ContactService } from './services/contact.service';
import { CountriesService } from './services/countries.service';
import { CustomerTypesService } from './services/customer-types.service';
import { DocumentService } from './services/document.service';
import { OfferService } from './services/offer.service';
import { PaymentMethodsService } from './services/payment-methods.service';
import { PaymentTermsService } from './services/payment-terms.service';
import { SalesStatsService } from './services/sales-stats.service';
import { UserService } from './services/user.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AuthService,
    BusinessCentralService,
    ContactService,
    CountriesService,
    CustomerTypesService,
    DocumentService,
    OfferService,
    PaymentMethodsService,
    PaymentTermsService,
    SalesStatsService,
    UserService,
    ApiConfiguration
  ],
})
export class TassulloApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<TassulloApiModule> {
    return {
      ngModule: TassulloApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: TassulloApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('TassulloApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
